import { Chatroom, TaggedTemplateCollection } from '../models';
import { getChatrooms, getTaggedTemplateCollections } from '../utils';
import { defer } from 'react-router-dom';

export type Data = [
  chatrooms: Chatroom[],
  taggedTemplateCollections: TaggedTemplateCollection[],
];

export const chatroomListLayoutLoader = async () => {
  const chatrooms = getChatrooms();
  const taggedTemplateCollections = getTaggedTemplateCollections();
  const data = Promise.all([chatrooms, taggedTemplateCollections]);
  return defer({
    data,
  });
};
